import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";


import "./style.css";
import { i18n } from '../../../translate/i18n';
import { useNotification } from "hooks/notification";
import { putRequest } from "utils/request";
import { addMonths, format } from "date-fns";

export default function TabAdministration({ companyData, handleUpdate }) {
  const [loading, setLoading] = useState(false);
  const [configs, setConfigs] = useState({});
  const { selectedCompany, listCompanies, setListCompanies } = useNotification();

  useEffect(() => {
    setConfigs({...selectedCompany, dueDay: selectedCompany.dueDay > 28 ? 28 : selectedCompany.dueDay});
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    putRequest('/companies/trialconfigs/update', {
      companyId: companyData.id,
      usersLimit: configs.usersLimit,
      trial: configs.trial ? 1 : 0,
      trialValidate: configs.trialLimit ? configs.trialLimit : null,
      dueDay: configs.dueDay
    }).then(e => {
      if(e.success) {
        let companyIndex = listCompanies.findIndex(e => e.id === companyData.id);
        listCompanies[companyIndex].trial = configs.trial ? 1 : 0;
        listCompanies[companyIndex].dueDay = configs.dueDay;
        listCompanies[companyIndex].usersLimit = configs.usersLimit;
        listCompanies[companyIndex].trialLimit = configs.trialLimit ? format(new Date(addMonths(new Date(configs.trialLimit), 1)), 'yyyy-MM-dd') : null;
        setListCompanies([...listCompanies]);
      }
      setLoading(false);
    })
  }

  const renewMonth = () => {
    setLoading(true);
    putRequest('/companies/trialconfigs/update', {
      companyId: companyData.id,
      usersLimit: configs.usersLimit,
      trial: configs.trial ? 1 : 0,
      dueDay: configs.dueDay,
      trialValidate: configs.trialLimit ? format(new Date(addMonths(new Date(configs.trialLimit), 1)), 'yyyy-MM-dd') : format(new Date(addMonths(new Date(), 1)), 'yyyy-MM-dd')
    }).then(e => {
      if(e.success) {
        let companyIndex = listCompanies.findIndex(e => e.id === companyData.id);
        listCompanies[companyIndex].trialValidate = configs.trialLimit ? format(new Date(addMonths(new Date(configs.trialLimit), 1)), 'yyyy-MM-dd') : null;
        setConfigs({ ...configs, trialLimit: configs.trialLimit ? format(new Date(addMonths(new Date(configs.trialLimit), 1)), 'yyyy-MM-dd') : format(new Date(addMonths(new Date(), 1)), 'yyyy-MM-dd')})
        setListCompanies([...listCompanies]);
      }
      setLoading(false);
    })
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setConfigs({ ...configs, [name]: value })
  }

  const handleResetDate = (e) => {
    setConfigs({...configs, trialLimit: selectedCompany.trialLimit})
  }

  return (
    <div className="list-container">
      <div className="title-helper-container" style={{marginBottom: 10}}>
        <h3>{companyData.nickName}</h3>
      </div>
      {!loading ? (
        <div className="container-area-config">
          <form onSubmit={handleSubmit}>
            <div className="form-group col-md-4">
              <label>{i18n.t('validDate')} *</label>
                <input
                  type="number"
                  min={'1'}
                  max={'28'}
                  className="form-control"
                  name="dueDay"
                  onChange={handleInputChange}
                  value={configs.dueDay}
                  required
                />
            </div>
            <div className="form-group col-md-4">
              <label>{i18n.t('maxUsers')} </label>
                <input
                  type="number"
                  name="usersLimit"
                  className="form-control"
                  min={'1'}
                  value={configs.usersLimit}
                  required
                  onChange={handleInputChange}
                />
            </div>
            <div className="trial-checkbox">
              <input
                type="checkbox"
                className="form-control"
                name="trial"
                style={{width: 20, height: 20}}
                checked={configs.trial}
                onChange={() => setConfigs({...configs, trial: !configs.trial})}
              />
              <label>Trial </label>
            </div>
            <div className="form-group col-md-4">
              <label>{i18n.t('toleranceDays')}: 5</label>
            </div>
            <div className="form-group col-md-4">
              <label>{i18n.t('acessLimitDate')}</label>
                <input
                  type="date"
                  className="form-control"
                  value={configs.trialLimit}
                  name="trialLimit"
                  onChange={handleInputChange}
                />
            </div>
            <div style={{display: 'flex', flexDirection: 'row', width: '25vw'}}>
              <button onClick={renewMonth} type="button" className="btn btn-outline-success" style={{marginRight: 10}}>
                <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('renewForMonth')}
              </button>
              <button type="button" onClick={handleResetDate} className="btn btn-outline-success">
                <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('reset')}
              </button>
            </div>
            <button style={{position: 'absolute', bottom: 30, right: 30}} onClick={handleSubmit} type="submit" className="btn btn-outline-success">
              <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
            </button>
          </form>
        </div>
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
    </div>
  );
}
